"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PositioningProfileEnum = void 0;
var PositioningProfileEnum;
(function (PositioningProfileEnum) {
    PositioningProfileEnum["BOTTOM_UP"] = "BOTTOM_UP";
    PositioningProfileEnum["DRAW"] = "DRAW";
    PositioningProfileEnum["LOSS_POSITION"] = "LOSS_POSITION";
    PositioningProfileEnum["RANDOM"] = "RANDOM";
    PositioningProfileEnum["TOP_DOWN"] = "TOP_DOWN";
    PositioningProfileEnum["WATERFALL"] = "WATERFALL";
})(PositioningProfileEnum || (exports.PositioningProfileEnum = PositioningProfileEnum = {}));
//# sourceMappingURL=positioning_profile.js.map